<template>
    <v-dialog v-model="dialog" scrollable max-height="auto" :max-width="($vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm') ? '90%' : '40%'" persistent>
        <v-card outlined prominent class="mx-auto elevation-0 overflow-y-auto" :loading="loading">

            <v-card-title class="ma-0 pa-0">
                <v-app-bar dense height="45" class="mb-4 elevation-1">
                    <v-toolbar-title class="subtitle-1">
                        Filtrar turmas
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon @click.native="clearFilter()" v-bind="attrs" v-on="on">
                                <v-icon color="primary lighten-2">mdi-filter-remove-outline</v-icon>
                            </v-btn>
                        </template>
                        <span>Limpar Filtro</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn icon @click.native="dialog = false" v-bind="attrs" v-on="on">
                                <v-icon color="red lighten-2">mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Fechar</span>
                    </v-tooltip>
                </v-app-bar>
            </v-card-title>

            <v-card-text class="pt-2">
                <v-container>
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="campuses"
                                :items="campusItems"
                                item-value="id"
                                item-text="name"
                                label="Campus"
                                multiple
                                clearable
                                small-chips
                                deletable-chips
                                dense
                                no-data-text="Nenhum campus nas turmas do período"
                            >
                                <template v-slot:prepend-item>
                                    <v-list-item ripple @mousedown.prevent @click="toggleAll('campuses', campusItems)">
                                        <v-list-item-action>
                                            <v-icon :color="campuses.length ? 'primary' : ''">{{ selectAllIcon(campuses, campusItems) }}</v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>Selecionar todos</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2" />
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="shifts"
                                :items="shiftItems"
                                item-value="id"
                                item-text="name"
                                label="Turno"
                                :disabled="!campuses.length"
                                :hint="!campuses.length ? 'Selecione o campus' : ''"
                                persistent-hint
                                multiple
                                clearable
                                small-chips
                                deletable-chips
                                dense
                                no-data-text="Nenhum turno para a seleção"
                            >
                                <template v-slot:prepend-item>
                                    <v-list-item ripple @mousedown.prevent @click="toggleAll('shifts', shiftItems)">
                                        <v-list-item-action>
                                            <v-icon :color="shifts.length ? 'primary' : ''">{{ selectAllIcon(shifts, shiftItems) }}</v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>Selecionar todos</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2" />
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="courses"
                                :items="courseItems"
                                item-value="id"
                                item-text="name"
                                label="Curso"
                                :disabled="!shifts.length"
                                :hint="!shifts.length ? 'Selecione o turno' : ''"
                                persistent-hint
                                multiple
                                clearable
                                small-chips
                                deletable-chips
                                dense
                                no-data-text="Nenhum curso para a seleção"
                            >
                                <template v-slot:prepend-item>
                                    <v-list-item ripple @mousedown.prevent @click="toggleAll('courses', courseItems)">
                                        <v-list-item-action>
                                            <v-icon :color="courses.length ? 'primary' : ''">{{ selectAllIcon(courses, courseItems) }}</v-icon>
                                        </v-list-item-action>
                                        <v-list-item-content>
                                            <v-list-item-title>Selecionar todos</v-list-item-title>
                                        </v-list-item-content>
                                    </v-list-item>
                                    <v-divider class="mt-2" />
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-autocomplete
                                v-model="workTimeDates"
                                :items="workTimeDateItems"
                                item-value="id"
                                item-text="name"
                                label="Subperíodo"
                                multiple
                                clearable
                                small-chips
                                deletable-chips
                                dense
                                no-data-text="Nenhum subperíodo para a seleção"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="success" @click.prevent.stop="filter()" :disabled="disableButton">
                    Filtrar
                    <v-icon right dark>mdi-filter-menu-outline</v-icon>
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    name: "SysGroupFilter",
    data: () => ({
        dialog: false,
        loading: false,
        options: { combinations: [], campuses: [], shifts: [], courses: [], workTimeDates: [] },
        campuses: [],
        shifts: [],
        courses: [],
        workTimeDates: [],
    }),
    props: {
        show: {
            type: Boolean,
            default: false
        },
    },
    computed: {
        disableButton() {
            return !this.campuses.length && !this.shifts.length && !this.courses.length && !this.workTimeDates.length;
        },

        // Cascata: cada lista considera só as turmas que atendem às seleções dos filtros anteriores.
        shiftCombinations() {
            return this.combinationsBy({ campus_id: this.campuses });
        },

        courseCombinations() {
            return this.combinationsBy({ campus_id: this.campuses, shift_id: this.shifts });
        },

        workTimeDateCombinations() {
            return this.combinationsBy({ campus_id: this.campuses, shift_id: this.shifts, course_id: this.courses });
        },

        campusItems() {
            return this.itemsFrom(this.options.combinations, 'campus_id', this.options.campuses);
        },

        // Cada nível só lista opções depois que o nível acima tiver seleção.
        shiftItems() {
            if (!this.campuses.length) return [];

            return this.itemsFrom(this.shiftCombinations, 'shift_id', this.options.shifts);
        },

        courseItems() {
            if (!this.shifts.length) return [];

            return this.itemsFrom(this.courseCombinations, 'course_id', this.options.courses);
        },

        workTimeDateItems() {
            return this.itemsFrom(this.workTimeDateCombinations, 'work_time_date_id', this.options.workTimeDates);
        },
    },
    watch: {
        dialog(val) {
            this.$emit('update:show', val);
        },

        show(val) {
            this.dialog = val;

            if (val) {
                this.loadOptions();
            }
        },

        // Ao mudar um filtro, descarta as seleções dos filtros seguintes que deixaram de existir.
        campuses() {
            this.shifts = this.keepValid(this.shifts, this.shiftItems);
        },

        shifts() {
            this.courses = this.keepValid(this.courses, this.courseItems);
        },

        workTimeDateItems() {
            this.workTimeDates = this.keepValid(this.workTimeDates, this.workTimeDateItems);
        },
    },
    methods: {
        ...mapActions('group', ['ActionGetGroupFilterOptions']),

        loadOptions() {
            this.loading = true;

            this.ActionGetGroupFilterOptions()
                .then((res) => {
                    this.options = res.data;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        combinationsBy(selected) {
            return this.options.combinations.filter(c =>
                Object.keys(selected).every(key => !selected[key].length || selected[key].includes(c[key]))
            );
        },

        itemsFrom(combinations, key, names) {
            const ids = new Set(combinations.map(c => c[key]).filter(id => id !== null));

            return names.filter(n => ids.has(n.id));
        },

        allSelected(selected, items) {
            return items.length > 0 && items.every(i => selected.includes(i.id));
        },

        selectAllIcon(selected, items) {
            if (this.allSelected(selected, items)) return 'mdi-close-box';

            return selected.length ? 'mdi-minus-box' : 'mdi-checkbox-blank-outline';
        },

        toggleAll(field, items) {
            this[field] = this.allSelected(this[field], items) ? [] : items.map(i => i.id);
        },

        keepValid(selected, items) {
            const valid = new Set(items.map(i => i.id));
            const kept = selected.filter(id => valid.has(id));

            return kept.length === selected.length ? selected : kept;
        },

        filter() {

            const columns = {};

            if (this.campuses.length)       columns.campus_id           = this.campuses.join(',');
            if (this.shifts.length)         columns.shift_id            = this.shifts.join(',');
            if (this.courses.length)        columns.course_id           = this.courses.join(',');
            if (this.workTimeDates.length)  columns.work_time_date_id   = this.workTimeDates.join(',');

            this.$emit('filter', { find_columns: columns });
        },

        clearFilter() {
            this.campuses = [];
            this.shifts = [];
            this.courses = [];
            this.workTimeDates = [];
            this.$emit('filter', null);
        },
    }
}
</script>
